import React from 'react';
import cn from 'classnames';

import styles from './small-text.module.scss';

interface ISmallTextProps {
  children: any;
  className?: string;
}

export default function SmallText({ children, className }: ISmallTextProps) {
  return (
    <small className={cn(styles.small, className)}>
      {children}
    </small>
  );
}
